import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./config/i18n";
import { routerList } from "./config/routerList";
import RequireAuth from "./component/RequireAuth";
import { Fragment } from "react";
import { NewYearAudioProvider } from "./contexts/NewYearAudioProvider";
import { ToastContainer } from "react-toastify";
// Bắt buộc từ v11 — thiếu file này toast sẽ hiện ra không có style.
import "react-toastify/dist/ReactToastify.css";
// Override của app — thứ tự sau dòng trên là bắt buộc.
import "./assets/styles/web-v3-styles/toast.css";
import { createPortal } from 'react-dom';
import { handleCheckAutoLogin } from "./helper/helper";
import { SoundProvider } from './contexts/SoundContext';
import { LoginModalProvider } from './contexts/LoginModalContext';
import Login from './page/Login/Login';
import { IS_UPDATE_VERSION_3_PROJECT, IS_UPDATE_VERSION_3_PROJECT_LOGIN } from '@/helper/const';
import LayoutApp from './layout/LayoutApp';
import { useSelector } from 'react-redux';
import { curStateAccount } from './Redux/selector';
import { hasAuthCookie } from './utils/auth';

function App() {
  const isCheckAutoLogin = handleCheckAutoLogin() && !sessionStorage.getItem("logout");
  const account = useSelector(curStateAccount);

  const isAuthed =
    hasAuthCookie() || Boolean(account?.userInfo) || Boolean(account?.token);

  // Phần Routes dùng chung cho cả 2 version — chỉ khác cách bọc Layout
  const renderRoutes = (wrapWithLayout) => (
    <Routes>
      {routerList.map((route, index) => {
        const Page = route.component;

        let element;
        if (wrapWithLayout) {
          // v2: giữ nguyên y hệt logic cũ — mỗi route tự bọc Layout riêng
          let Layout = null;
          if (route.layout) {
            Layout = route.layout;
          } else if (route.layout === null) {
            Layout = Fragment;
          }
          const page = (
            <Layout>
              <Page />
            </Layout>
          );
          element = route.public || isCheckAutoLogin ? page : <RequireAuth>{page}</RequireAuth>;
        } else {
          // v3: LayoutApp đã bọc ngoài rồi -> Route chỉ trả Page trần
          element = route.public || isCheckAutoLogin ? <Page /> : <RequireAuth><Page /></RequireAuth>;
        }

        return <Route key={index} path={route.path} element={element} />;
      })}
    </Routes>
  );

  return (
    <>
      {createPortal(
        <ToastContainer position="top-center" hideProgressBar style={{ zIndex: 999999 }} />,
        document.body
      )}
      <Router>
        <LoginModalProvider>
          <SoundProvider isLoggedIn={isAuthed}>
            <NewYearAudioProvider>
              {IS_UPDATE_VERSION_3_PROJECT_LOGIN ? (
                // v3: LayoutApp cố định ngoài Routes -> mount 1 lần, hết nháy
                <LayoutApp>
                  {renderRoutes(false)}
                </LayoutApp>
              ) : (
                // v2: giữ nguyên hành vi cũ, mỗi route tự có Layout riêng
                renderRoutes(true)
              )}
            </NewYearAudioProvider>
          </SoundProvider>
          <Login />
        </LoginModalProvider>
      </Router>
    </>
  );
}

export default App;